// import Container from 'react-bootstrap/Container';
import pdfFile from '../divyatailanguiux.pdf';
import Button from 'react-bootstrap/Button';
import WhatsAppIcon from './WhatsAppIcon';
export default function Home() {

  return (
    <>
      <section className="hero-section d-flex align-items-center justify-content-center text-center">
<WhatsAppIcon />
        {/* Background */}
        <div className="hero-bg"></div>

        {/* Overlay */}
        <div className="overlay"></div>

        {/* Content */}
        <div className="container heroWrapper position-relative z-1">
        
          <h3  className='display-6'>
            Hello There 👋
          </h3>
          <h1 className='display-1 fw-bold' >
            " DIVYA TAILANG "
          </h1>
          <h4 className='display-6'>
           Creative <span className='text-info'>UI/UX Designer ❤️</span>
          </h4>
          <div>
            <a className="my-1 ms-2" target="_/blank" href={pdfFile}>
              <Button variant="danger" className='fs-6 px-3 my-2' style={{ borderRadius: "14px" }}>Download CV</Button>
            </a>
            
          </div>
        </div>

        {/* Bottom Glow Line */}
        <div className="curve-wrapper">
          <svg
            viewBox="0 0 1440 200"
            preserveAspectRatio="none"
            className="curve-svg"
          >
            <defs>
              <linearGradient id="lineGradient">
                <stop offset="0%" stopColor="#ff0055" />
                <stop offset="50%" stopColor="#ed3ab1" />
                <stop offset="100%" stopColor="#ff6600" />
              </linearGradient>

              <filter id="glow">
                <feGaussianBlur stdDeviation="6" result="blur" />
                <feMerge>
                  <feMergeNode in="blur" />
                  <feMergeNode in="SourceGraphic" />
                </feMerge>
              </filter>
            </defs>

            {/* Glow */}
            <path
              d="M0,120 C300,40 1100,220 1440,100"
              stroke="url(#lineGradient)"
              strokeWidth="10"
              fill="transparent"
              filter="url(#glow)"
            />

            {/* Main Line */}
            <path
              d="M0,120 C300,40 1100,220 1440,100"
              stroke="url(#lineGradient)"
              strokeWidth="8"
              fill="transparent"
            />
          </svg>
        </div>
      </section>
    </>
    // <Container className='d-none'>
    //   <span className="heroWrapper">


    // </Container>
  )
}
